import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { SheetsService } from './sheets.service';
import { SearchObjectService } from '../../services/search-object.service';

@Component({
  selector: 'app-sheets',
  templateUrl: './sheets.component.html',
  styleUrls: ['./sheets.component.scss']
})
export class SheetsComponent implements OnInit, OnDestroy {

  sheetsSubscription;
  showSheets: boolean;
  maxHeight = 100;

  // map data
  sheetType;
  resultData;

  @ViewChild('content', { static: true }) content: ElementRef;

  constructor(private renderer: Renderer2, 
    private searchObjectService: SearchObjectService,
    private sheetsService: SheetsService) {
    this.showSheets = false;
    this.sheetsSubscription = this.sheetsService.sheetsSub.subscribe((resultData) => {
      this.resultData = resultData;
      this.showSheets = !this.showSheets;
      if (this.showSheets) {
        this.renderer.setStyle(this.content.nativeElement, "max-height", `${this.maxHeight}vh`);
      }
    });
   }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    if (this.sheetsSubscription) {
      this.sheetsSubscription.unsubscribe();
    }
  }

  getSheets() {
    return this.showSheets;
  }

  foldSheets() {
    this.renderer.setStyle(this.content.nativeElement, "max-height", '0vh');
    this.showSheets = false;
  }

  onTouchMove(e) {
    let newHeight = window.innerHeight - e.changedTouches[0].clientY;
    this.renderer.setStyle(this.content.nativeElement, "max-height", `${newHeight}px`);
  }
  
  onTouchEnd(e) {
    let newHeight = window.innerHeight - e.changedTouches[0].clientY;
    if (newHeight < this.content.nativeElement.offsetHeight) {
      this.foldSheets();
    }

  }

  getTextForTier(tier: string) {
    return  (this.searchObjectService.isFormularyIdCheck() ? (tier == '1' ? 'Generic': 'Brand') : ('Tier ' + tier));
  }

}
